<template>
  <section class="common-getCode">
    <span class="getCode-button text-primary" @click="start" v-if="flag">{{
      $t("common.getCode")
    }}</span>
    <span v-else class="text-muted">{{ num }}s</span>
  </section>
</template>

<script>
import bus from "@/apis/bus";
export default {
  data() {
    return {
      defineNum: 60, // 默认秒
      num: 0,
      flag: true,
      timer: null,
    };
  },
  created() {
    bus.$on("getCodeStart", () => {
      this.start();
    });
    bus.$on("getCodeClear", () => {
      this.clear();
    });
  },
  methods: {
    start() {
      this.$emit("getCodeClick");
      this.clear();
      this.num = this.defineNum;
      this.flag = false;
      this.timer = setInterval(() => {
        this.num = this.num - 1;
        if (this.num === 0) {
          this.clear();
        }
      }, 1000);
    },
    clear() {
      clearInterval(this.timer);
      this.num = 0;
      this.flag = true;
    },
  },
};
</script>

<style lang="scss">
.common-getCode {
  .getCode-button {
    cursor: pointer;
  }
  .text-primary {
    color: #095be8 !important;
  }
}
</style>

